module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Bread-199cca204a4c5d856e28ff1bd7ea6af371db5428b5f9843db600fc9f10d4293e.svg";